<template>
    <div class="modal-settings-limits-edit modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Лимиты</h2>
          <button type="button" class="close" @click="$emit('hide')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md">
              <div class="form-group">
                <label>Порог количества купюр в автомате, шт.</label>
                <input type="number" class="form-control" v-model="machine.banknotes_count_threshold" min="0">
              </div>
            </div>
            <div class="col-md-7">
              <div class="w-100">
                <div class="row">
                  <div class="col-md">
                    <div class="form-group">
                      <label>Порог монет на тубу, шт.</label>
                      <input type="number" class="form-control" v-model="machine.coins_tube_threshold" min="0">
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label>Порог монет на тубу после сервиса, шт.</label>
                      <input type="number" class="form-control" v-model="machine.coins_tube_threshold_after_service" min="0">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-8">
              <div class="w-100">
                <div class="row">
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>Порог на сумму монет, руб.</label>
                      <input type="number" class="form-control" v-model="machine.coins_summary_threshold" min="0">
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label>Порог на сумму монет после сервиса, руб.</label>
                      <input type="number" class="form-control" v-model="machine.coins_summary_threshold_after_service" min="0">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md">
              <div class="form-group">
                <label>Минимальная периодичность обслуживания, дни.</label>
                <input type="number" class="form-control" v-model="machine.service_interval_threshold" min="0">
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md">
              <div class="w-100">
                <div class="row">
                  <div class="col-md">
                    <div class="form-group">
                      <label>Порог на простой без продаж, ч.</label>
                      <input type="number" class="form-control" v-model="machine.no_sales_time_threshold" min="0">
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label>Порог на простой без купюр, ч.</label>
                      <input type="number" class="form-control" v-model="machine.no_banknote_time_threshold" min="0">
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label>Порог на простой без монет, ч.</label>
                      <input type="number" class="form-control" v-model="machine.no_coin_time_threshold" min="0">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md">
              <div class="w-100">
                <div class="row">
                  <div class="col-md">
                    <div class="form-group">
                      <label>Порог на низкую температуру, C.</label>
                      <input type="text" class="form-control" v-model="machine.temperature_low_threshold">
                    </div>
                  </div>
                  <div class="col-md">
                    <div class="form-group">
                      <label>Порог на высокую температуру, C.</label>
                      <input type="text" class="form-control" v-model="machine.temperature_high_threshold">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <btn-action class="btn btn-primary" @click="save">Сохранить</btn-action>
          <button type="button" class="btn btn-light" @click="$emit('hide')">Отмена</button>
        </div>
      </div>
    </div>
</template>

<script>
  import api from '@/api'

  export default {
    props: ['value', 'currentMachine', 'ids'],
    watch: {},
    computed: {
      machine: function () {
        return this.currentMachine || {}
      },
    },
    methods: {
      save () {
        return api.post(`limits/`, {
          ids: this.ids || [ this.machine.id ],
          banknotes_count_threshold: this.machine.banknotes_count_threshold,
          coins_tube_threshold: this.machine.coins_tube_threshold,
          coins_tube_threshold_after_service: this.machine.coins_tube_threshold_after_service,
          coins_summary_threshold: this.machine.coins_summary_threshold,
          coins_summary_threshold_after_service: this.machine.coins_summary_threshold_after_service,
          service_interval_threshold: this.machine.service_interval_threshold,
          no_sales_time_threshold: this.machine.no_sales_time_threshold,
          no_banknote_time_threshold: this.machine.no_banknote_time_threshold,
          no_coin_time_threshold: this.machine.no_coin_time_threshold,
          temperature_low_threshold: this.machine.temperature_low_threshold,
          temperature_high_threshold: this.machine.temperature_high_threshold,
        }).then(() => this.$emit('hide', this.machine))
      },
    },
  }
</script>

<style lang="scss">
  @import "boot";
  .modal-settings-limits-edit {
    .modal-body {
      [class*="col-"] {
        display: flex;
      }
      .card {
        width: 100%;
        margin-bottom: map-get($spacers, 4);
      }
      .card-body {
        display: flex;
        align-items: flex-end;
        .row {
          align-items: flex-end;
        }
      }
      .form-group {
        width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/limits/edit-modal.vue